import { MONTHLY, WEEKLY, YEARLY } from '~/constants/dateDurations';

export default function getRentalLabels(
  duration: number | null,
  translations: {
    yearly: string;
    monthly: string;
    weekly: string;
    daily: string;
  },
) {
  if (duration === null || duration <= 0) {
    return null; // Return null for invalid durations
  }

  const totalDays = Math.max(Math.floor(duration), 0);
  if (totalDays === YEARLY) return translations.yearly;
  if (totalDays === MONTHLY) return translations.monthly;
  if (totalDays === WEEKLY) return translations.weekly;
  return translations.daily;
}
